import styled from 'styled-components';
import * as Accordion from '@radix-ui/react-accordion';

export const StyledAccordionTrigger = styled(Accordion.Trigger)<{
  $textColor?: string;
}>`
  color: ${({ $textColor }) => $textColor};
`;
